<router-outlet></router-outlet>
<script src="/assets/js/swiper.js"></script>
<script src="/assets/js/menu.js"></script>
<script src="/assets/js/script.js"></script>